import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/Header";
import { KnowledgeConnections } from "@/components/knowledge/KnowledgeConnections";
import { Footer } from "@/components/Footer";
import { BreadcrumbNav } from "@/components/BreadcrumbNav";
import { JsonLd } from "@/components/JsonLd";
import { generateCanonicalUrl } from "@/utils/seoHelpers";

const GoogleAdsSugarLandPage = () => {
  const [language, setLanguage] = useState<'es' | 'en'>('es');
  const toggleLanguage = () => setLanguage(language === 'es' ? 'en' : 'es');
  const canonicalUrl = generateCanonicalUrl('/google-ads-sugar-land');

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Google Ads en Sugar Land TX",
    "provider": { "@id": "https://luisroc.com/#organization" },
    "areaServed": { "@type": "City", "name": "Sugar Land" }
  };

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>Google Ads Sugar Land TX | Campañas PPC – Luis ROC</title>
        <meta name="description" content="Campañas Google Ads en Sugar Land con segmentación local. Activa demanda mediante campañas pagadas." />
        <meta name="keywords" content="google ads sugar land tx, ppc sugar land" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <JsonLd data={serviceSchema} />

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={toggleLanguage} />
        
        <main className="container mx-auto px-4 py-8">
          <BreadcrumbNav 
            items={[
              { name: "Servicios", url: "/servicios" },
              { name: "Localidades", url: "/servicios-locales-houston" },
              { name: "Google Ads Sugar Land", url: "/google-ads-sugar-land" }
            ]}
            language="es"
          />

          <section className="py-16 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Google Ads en Sugar Land TX
            </h1>
            
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto mb-8">
              Campañas PPC optimizadas para Sugar Land con segmentación local precisa.
            </p>

            <Button size="lg" onClick={() => window.location.href = '/contacto'}>
              Reunión inicial gratuita de 30 minutos
            </Button>
          </section>
        </main>

        <KnowledgeConnections path="/google-ads-sugar-land" language={language} />

        <Footer language={language} />
      </div>
    </>
  );
};

export default GoogleAdsSugarLandPage;
